<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator-class="el-icon-arrow-right" v-if="content_id || showBottons">
        <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }">Panel</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db + '/pages'}">Páginas</el-breadcrumb-item>
        <el-breadcrumb-item
          v-if="page"
          :to="{ path: '/dashboard/' + $route.params.db + '/pages/edit/' + $route.params.page }"
        >{{page.title}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="form && $route.params.content_id == null">Sección {{form.title}}</el-breadcrumb-item>
        <el-breadcrumb-item
          v-else-if="$route.params.content_id"
          :to="{ path: '/dashboard/' + $route.params.db + '/pages/' + $route.params.page  + '/seccion/' + $route.params.section_id }"
        >Sección {{form.title}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.params.content_id">Editando contenido</el-breadcrumb-item>
        <el-breadcrumb-item v-else-if="statusToBreadCrud">Nuevo contenido</el-breadcrumb-item>
      </el-breadcrumb>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-else>
        <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }">Panel</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db + '/pages'}">Páginas</el-breadcrumb-item>
        <el-breadcrumb-item
          v-if="page"
          :to="{ path: '/dashboard/' + $route.params.db + '/pages/edit/' + $route.params.page }"
        >{{page.title}}</el-breadcrumb-item>
        <el-breadcrumb-item
          v-if="$route.params.section_id && form.title"
        >Editando sección: {{form.title}}</el-breadcrumb-item>
        <el-breadcrumb-item v-else-if="form.title">Nueva sección: {{form.title}}</el-breadcrumb-item>
        <el-breadcrumb-item v-else>Nueva sección</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <br />
    <el-card class="box-card">
      <h2>{{form.title}}</h2>
      <el-form @submit.native.prevent="submit" ref="form" label-position="top" id="contenido">
        <el-row type="flex" justify="start">
          <el-col :span="5">
            <el-form-item label="Título / Nombre en menú" :class="(errorTitle ? 'error' : false)">
              <el-input v-model="form.title" :disabled="disabled"></el-input>
              <div v-if="errorTitle" class="el-form-item__error">El título es obligatorio</div>
            </el-form-item>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="5">
            <el-form-item label="URL">
              <el-input v-model="form.url" :disabled="disabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="5">
            <el-form-item label="Icono">
              <el-input v-model="form.icon" :prefix-icon="form.icon"></el-input>
              <a
                :href="'/dashboard/' + $route.params.db + '/icons/'"
                target="_blank"
                class="link"
              >Iconos</a>
            </el-form-item>
          </el-col>

          <el-col :span="1"></el-col>
          <el-col :span="5" v-if="form.url.length > 3 && !$route.params.content_id">
            <el-form-item label="Seleccionar plantilla">
              <el-button type="info" @click="templatesVisible = true">Añadir contenido</el-button>

              <!-- <select class="select" :class="(errorTemplateId ? 'error' : false)" v-model="tipeTemplate" @change="onChange($event.target.value)">
                                <option v-for="(item, i) in template" :key="i" :value="item.id"> {{item.template}} </option>
                            </select>
              <div v-if="errorTemplateId" class="el-form-item__error">Seleccione un valor válido</div>-->
            </el-form-item>
          </el-col>
        </el-row>
        <el-dialog title="Selecciona un tipo de plantilla" :visible.sync="templatesVisible">
          <el-tooltip
            class="item"
            effect="dark"
            content="Plantilla para contenidos planos"
            placement="top"
          >
            <img
              @click.prevent="onChange(1)"
              src="/static/img/icon-templates/1810-Nueva plantilla-01.png"
            />
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="Plantilla para contenidos de tipo blog / entradas"
            placement="top"
          >
            <img
              @click.prevent="onChange(2)"
              src="/static/img/icon-templates/1810-Listado entradas_blog-01.png"
            />
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="Plantilla para crear listas de docuemntos"
            placement="top"
          >
            <img
              @click.prevent="onChange(3)"
              src="/static/img/icon-templates/1810-Listado entradas_docs-01.png"
            />
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="Plantilla para crear galerías de imágenes"
            placement="top"
          >
            <img
              @click.prevent="onChange(4)"
              src="/static/img/icon-templates/1810-Galeria img-01.png"
            />
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="Plantilla para crear formularios / encuestas"
            placement="top"
          >
            <img
              @click.prevent="onChange(5)"
              src="/static/img/icon-templates/1810-Formularios-01.png"
            />
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="Plantilla para enlazar otras secciones"
            placement="top"
          >
            <img
              @click.prevent="onChange(6)"
              src="/static/img/icon-templates/1810-Enlaces extrenos-01.png"
            />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="Plantilla crear fichas" placement="top">
            <img @click.prevent="onChange(7)" src="/static/img/icon-templates/1811-Fichas-01.png" />
          </el-tooltip>
        </el-dialog>
      </el-form>
    </el-card>
    <br />
    <el-card class="box-card" v-if="!content_id && !showTenplate">
      <template>
        <app-modal-draggable
          v-if="modalDraggable"
          :content="fechItems"
          :name="'title'"
          :table="'contents'"
        ></app-modal-draggable>
        <app-table-paginate
          v-if="fechItems.length > 0"
          :routeEdit="routeEdit"
          :tableQuery="fechItems"
          :tableColumns="tableColumns"
          :table="tableDelete"
          :preview="preview"
          :desktop="true"
          :search="true"
          :draggable="true"
          :duplicate="true"
          :move="true"
        ></app-table-paginate>
        <h2 v-else>Selecciona un tipo de plantilla para comenzar</h2>
      </template>
    </el-card>
    <el-card class="box-card" v-else>
      <app-template-contenido
        :id="id"
        :status="Tcontenido"
        :ida="id"
        :content="contentTemplate"
        v-if="Tcontenido"
      ></app-template-contenido>
      <app-template-listado
        :id="id"
        :status="Tcontenido"
        :content="contentTemplate"
        v-else-if="Tlistado"
      ></app-template-listado>
      <app-template-documental
        :id="id"
        :status="Tcontenido"
        :content="contentTemplate"
        v-else-if="Tdocumental"
      ></app-template-documental>
      <app-template-galeria
        :id="id"
        :status="Tcontenido"
        :content="contentTemplate"
        v-else-if="Tgaleria"
      ></app-template-galeria>
      <app-template-formulario
        :id="id"
        :status="Tcontenido"
        :content="contentTemplate"
        v-else-if="Tformulario"
      ></app-template-formulario>
      <app-template-calidad
        :id="id"
        :status="Tcontenido"
        :content="contentTemplate"
        v-else-if="Tcalidad"
      ></app-template-calidad>
      <app-template-ficha
        :id="id"
        :status="Tcontenido"
        :content="contentTemplate"
        v-else-if="Tficha"
      ></app-template-ficha>
    </el-card>
    <br />
    <el-card class="box-card">
      <el-row>
        <el-col :span="24">
          <button
            v-if="this.showBottons"
            type="submit"
            class="el-button el-button--primary"
            form="contenido"
          >
            <span>{{btn}}</span>
          </button>
          <el-button v-if="!$route.params.section_id" @click="close()">Cancelar</el-button>
          <el-button v-else @click="atras()">Atrás</el-button>
          <el-button v-if="btnPreview" type="info" @click="previsualizar()">
            <i class="el-icon-view"></i>
          </el-button>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import ApiService from "@/common/api.service";
import { mapActions, mapGetters, mapState } from "vuex";
import { FECTH_TIPO_MENU, FECTH_TEMPLATE_OPTIONS } from "@/store/actions.type";
import { INTRANET_URL } from "@/common/config";

import Draggable from "@/components/Dashboard/Modals/draggable";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";

import Contenido from "@/components/Dashboard/pages/templates/contenido";
import Listado from "@/components/Dashboard/pages/templates/listado";
import Documental from "@/components/Dashboard/pages/templates/documental";
import Galeria from "@/components/Dashboard/pages/templates/galeria";
import Formulario from "@/components/Dashboard/pages/templates/formulario";
import Calidad from "@/components/Dashboard/pages/templates/calidad";
import Ficha from "@/components/Dashboard/pages/templates/ficha";

export default {
  name: "seccion",
  components: {
    "app-table-paginate": tablaConPaginador,
    "app-template-contenido": Contenido,
    "app-template-listado": Listado,
    "app-template-documental": Documental,
    "app-template-galeria": Galeria,
    "app-template-formulario": Formulario,
    "app-template-calidad": Calidad,
    "app-template-ficha": Ficha,
    "app-modal-draggable": Draggable
  },
  async created() {
    this.$route.params.section_id
      ? (this.existUrl = false)
      : (this.existUrl = true);

    await this.getOptionsTemplate();
    await this.getOptionsMenu();

    this.$route.params.section_id
      ? (this.id = this.$route.params.section_id)
      : false;
    this.$route.params.content_id
      ? (this.btn = "Editar")
      : (this.btn = "Crear");

    this.$root.$on("delete", (id, row) => {
      if (this.$route.params.section_id) {
        this.eliminarRegistro(row.content_id, id);
      }
    });

    this.$root.$on("desktop", (id, row, value) => {
      if (this.$route.params.section_id) {
        this.updateDesktop(row, value);
      }
    });
    if (this.id) {
      this.showBottons = true;
      this.btn = "Actualizar";
      this.init();
    } else {
      this.getInfoPage();
    }

    this.$root.$on("duplicate", e => this.duplicate(e));
    this.$root.$on("draggable", e => this.showDraggable());
    this.$root.$on("closeModal", () => this.closeModal());
    this.move = "/dashboard/" + this.$route.params.db + "/form/edit/sections/";
  },
  watch: {
    $route(to) {
      this.$route.params.section_id
        ? (this.id = this.$route.params.section_id)
        : false;
      this.init();
    }
  },
  data() {
    return {
      tableColumns: [
        {
          label: "Título",
          prop: "title"
        },
        {
          label: "Plantilla",
          prop: "template"
        },
        {
          label: "Escritorio",
          prop: "desktop"
        }
      ],
      tableDataAPI: [],
      form: {
        id: "",
        title: "Nueva sección",
        url: "",
        menu_id: 2,
        icon: null
      },
      formOld: {
        id: "",
        title: "Nueva sección",
        url: "",
        menu_id: 2,
        icon: null
      },
      section: {},
      template: {},
      menu: {},
      routeEdit: null,
      preview: false,
      showSelectTemplate: false,
      tipeTemplate: null,
      errorTitle: false,
      errorURL: false,
      errorMenuId: false,
      errorTemplateId: false,
      Tcontenido: false,
      Tlistado: false,
      Tdocumental: false,
      Tgaleria: false,
      Tformulario: false,
      Tcalidad: false,
      Tficha: false,
      id: false,
      template_id: false,
      content_id: false,
      content: false,
      showTabla: false,
      showBottons: false,
      disabled: false,
      title: "Nueva sección",
      loading: false,
      contentTemplate: 0,
      tableDelete: "sections",
      show: false,
      page: null,
      btnPreview: false,
      existUrl: true,
      statusToBreadCrud: false,
      showTenplate: false,
      modalDraggable: false,
      move: false,
      templatesVisible: false
    };
  },
  methods: {
    async init() {
      this.routeEdit =
        "/dashboard/" +
        this.$route.params.db +
        "/pages/" +
        this.$route.params.page +
        "/seccion/" +
        this.id +
        "/content/";
      await this.getTableData();
      await this.getSection();
      await this.getInfoPage();
      this.showSelectTemplate = true;
      if (this.$route.params.content_id) {
        this.content_id = this.$route.params.content_id;
        this.template_id = this.$route.params.template_id;
        await this.mount();
      } else {
        this.content_id = null;
      }
      this.btnPreview =
        INTRANET_URL + "/modulo/" + this.page.url + "/" + this.form.url;
      this.show = true;
    },
    async getTableData() {
      this.tableDataAPI = [];
      let page = [
        "",
        "contenido",
        "listados",
        "documental",
        "galeria",
        "formulario",
        "calidad"
      ];

      const data = await ApiService.post("dashboard/listtablesectioncontents", {
        table: "contents",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        section_id: this.id
      });

      if (data.data !== "Algo ha fallado") {
        this.tableDataAPI = data.data.map(a => {
          a.desktop == 1 ? (a.desktop = "Sí") : (a.desktop = "No");
          a.move =
            "/dashboard/" +
            this.$route.params.db +
            "/form/edit/" +
            page[a.templateId] +
            "/" +
            a.id;
          return a;
        });
      }
    },
    async getSection() {
      const section = await ApiService.post("dashboard/table", {
        table: "sections",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.$route.params.section_id
      });
      if (section.status === 200) {
        this.section = section.data;
        this.form = section.data;
        this.formOld = section.data;
      }
    },
    async getInfoPage() {
      let id;
      this.id ? (id = this.$route.params.page) : (id = this.$route.params.id);

      const page = await ApiService.post("dashboard/table", {
        table: "pages",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: id
      });

      this.page = page.data;
    },
    async mount() {
      let content = await this.tableDataAPI.filter(t => {
        if (
          t.templateId == this.template_id &&
          t.registro_id == this.content_id
        ) {
          let a = {
            id: t.id,
            registro_id: t.registro_id,
            templateId: t.templateId
          };
          return a;
        }
      });
      this.contentTemplate = content[0].registro_id;
      this.onChange(content[0].templateId);
      this.tipeTemplate = content[0].templateId;
    },
    close() {
      this.$root.$emit("volver_a_páginas", "showNewContent");
    },
    atras() {
      if (this.content_id) {
        this.content_id = false;
        this.onChange(0);
        this.tipeTemplate = 0;
        this.showTabla = true;
      }
      this.$router.go(-1);
    },
    async onChangeMenu(value) {
      parseInt(value) != 0
        ? (this.showSelectTemplate = true)
        : (this.showSelectTemplate = false);
    },
    async onChange(value) {
      this.templatesVisible = false;
      this.Tcontenido = false;
      this.Tlistado = false;
      this.Tdocumental = false;
      this.Tgaleria = false;
      this.Tformulario = false;
      this.Tcalidad = false;
      this.Tficha = false;
      this.showTabla = false;

      this.showBottons = false;
      switch (parseInt(value)) {
        case 0:
          this.statusToBreadCrud = false;
          this.showBottons = false;
          break;
        case 1:
          this.Tcontenido = true;
          this.statusToBreadCrud = true;
          this.showBottons = true;
          break;
        case 2:
          this.Tlistado = true;
          this.statusToBreadCrud = true;
          this.showBottons = true;
          break;
        case 3:
          this.Tdocumental = true;
          this.statusToBreadCrud = true;
          this.showBottons = true;
          break;
        case 4:
          this.Tgaleria = true;
          this.statusToBreadCrud = true;
          this.showBottons = true;
          break;
        case 5:
          this.statusToBreadCrud = true;
          this.Tformulario = true;
          this.showBottons = true;
          break;
        case 6:
          this.statusToBreadCrud = true;
          this.Tcalidad = true;
          this.showBottons = true;
          break;
        case 7:
          this.statusToBreadCrud = true;
          this.Tficha = true;
          this.showBottons = true;
          break;
      }
      this.showBottons === true
        ? (this.showTenplate = true)
        : (this.showTenplate = false);
    },
    async submit() {
      this.onChangeMenu(0);
      this.onChange(0);
      this.show = false;
      if (this.$route.params.section_id && this.form.url == this.formOld.url) {
        this.existUrl = false;
      } else {
        const form = await this.formUrlNoExist();
      }

      if (this.existUrl === false) {
        if (this.form.title == "" || this.form.title == null) {
          this.errorTitle = true;
          this.$message.error({
            message: "El campo título es obligatorio"
          });
          return false;
        } else {
          await this.setSaveSection();
          await this.$root.$emit("saveContent", this.id);

          setTimeout(() => {
            this.getTableData();

            setTimeout(() => {
              let a = this.fechItems
                .map(e => {
                  return e.content_id;
                })
                .sort();

              let lastInsert = a[a.length - 1];
              /*
                                if(!this.content_id){
                                    this.fechItems.filter( e => {
                                        if(e.content_id === lastInsert){
                                            if(e.templateId == 2 || e.templateId == 3 || e.templateId == 4 || e.templateId == 7 ){
                                                this.$router.push(this.$router.currentRoute.path + '/content/' + e.id + '/' + e.templateId)
                                            }
                                        }
                                    })
                                }
                                */
              this.$router.go(this.$router.currentRoute);
            }, 2000);
          }, 2000);
        }
      }
    },
    async formUrlNoExist(value) {
      if (!this.$route.params.section_id) {
        const form = await ApiService.post("dashboard/chechUrl", {
          table: "sections",
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          url: this.form.url
        });
        if (form.data) {
          this.$message.error({
            message: "La url introducida ya está en uso"
          });
          this.existUrl = true;
        } else {
          this.existUrl = false;
        }
      }
    },
    async setSaveSection() {
      const a = await ApiService.post("dashboard/editform", {
        table: "sections",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.form,
        id: this.section.id
      });

      if (a.status === 200) {
        if (!this.section.id) {
          this.id = a.data;
          const section = await this.setPageSection();
          this.form = {};
        } else {
          this.msg(a);
        }
      }
    },
    async setPageSection() {
      const a = await ApiService.post("dashboard/editform", {
        table: "pages_sections",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: {
          page_id: this.$route.params.id,
          section_id: this.id
        }
      });
      this.msg(a.data);
    },
    msg(a) {
      if (a) {
        this.tipeTemplate = "0";
        this.onChange(0);

        this.title = "Sección: " + this.form.title;

        this.$notify({
          title: "Guardado",
          message: "Se ha guardado la entrada con éxito",
          type: "success"
        });
      } else {
        this.$notify.error({
          title: "Fallo",
          message: "Ago ha fallodo y no se ha modificado la entrada"
        });
      }
    },

    async getOptionsMenu() {
      const a = await this.$store.dispatch(FECTH_TIPO_MENU);
      this.menu = a;
    },
    async getOptionsTemplate() {
      const a = await this.$store.dispatch(FECTH_TEMPLATE_OPTIONS);
      this.template = a;
    },
    async eliminarRegistro(content_id, id) {
      const a = await ApiService.post("dashboard/removesectioncontents", {
        table: "sections",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        section_id: this.id,
        content_id: content_id
      });
      this.deleterow = a.data;
      this.$message({
        type: "success",
        message: "Se ha eliminado correctamente"
      });
      await this.getTableData();
    },
    async updateDesktop(row, value) {
      const a = await ApiService.put("dashboard/update-desktop", {
        table: "contents",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        registro_id: row.registro_id,
        templateId: row.templateId,
        value: value
      });
      this.deleterow = a.data;
      await this.getTableData();
    },
    previsualizar() {
      window.open(this.btnPreview, "_blank");
    },
    async duplicate(e) {
      let form = {
        id: e.registro_id,
        content_id: e.content_id
      };

      const a = await ApiService.post("dashboard/duplicate-content", {
        table: "pages",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: e,
        id: this.$route.params.id
      });
      if (a.data) {
        this.$notify({
          title: "Modificado",
          message: "Se ha duplicado la página con éxito",
          type: "success"
        });
        this.getTableData();
      } else {
        this.$notify.error({
          title: "Fallo",
          message: "Ago ha fallado y no se ha duplicado la página"
        });
      }
    },
    showDraggable() {
      this.modalDraggable = true;
    },
    async closeModal() {
      this.modalDraggable = false;
      await this.getTableData();
    }
  },
  computed: {
    fechItems() {
      return this.tableDataAPI;
    },
    ...mapGetters(["getPageActive"])
  }
};
</script>

<style lang="scss">
.el-dialog__body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 70px 10px;
}
.tipe__template {
  cursor: pointer;
  font-size: 90px;
  flex: auto;
  &:hover {
    color: #e6a23c;
  }
}
.item {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/pages/seccion.vue